import React, { useCallback } from "react";

import { FieldArray } from "../utils/components/form";
import { DeleteIcon, AddIcon } from "../utils/components/icons";
import ToggleMenu from "./toggleMenu";
import { InputField } from "./components";

const Rows = (props) => {
  let { fields, meta: { error }, readOnly } = props || {};

  const addField = useCallback(() => {
    if (fields.length < 10) {
      fields.push({});
    } else {
      alert("Es können nicht mehr als 10 Menüpunkte pro Spalte hinzugefügt werden!");
    }
  }, [fields]);

  const removeField = useCallback((e) => {
    if (!e) return;
    const target = e.currentTarget || e.target;
    const index = Number(target.dataset.index);
    if (isNaN(index)) return;
    fields.remove(index);
  }, [fields]);

  return (
    <div className='renderRows'>
      <ToggleMenu
        name="Menüpunkte"
        hasButton={!readOnly}
        button={!readOnly ? <button
          type="button"
          className="btn-link align-middle"
          onClick={addField}>
          <AddIcon>
          </AddIcon>
        </button> : null}
      >
        <div className="d-grid ps-one pe-one">
          {fields.map((row, index) => (
            <React.Fragment key={`row${row.roworder}`}>
              <div className="mb-1 d-flex">
                <InputField
                  name={`${row}.rowname`}
                  type="text"
                  label={"Name"}
                  readOnly={readOnly}
                />
                <InputField
                  name={`${row}.rowurl`}
                  type="text"
                  label={"Url"}
                  readOnly={readOnly}
                />
                <InputField
                  name={`${row}.roworder`}
                  type="hidden"
                  label={"Position"}
                  invisible={true}
                />
                <button type="button"
                  className="btn-link align-middle"
                  title="Remove"
                  data-index={index}
                  onClick={removeField}
                  disabled={readOnly}
                >
                  <DeleteIcon aria-hidden="true">
                  </DeleteIcon>
                </button>
              </div>
              {error && error[index] && error[index].rowurl
                ? <div className="alert alert-danger p-1">{error[index].rowurl}</div>
                : null
              }
            </React.Fragment>
          ))}

        </div>
      </ToggleMenu>
    </div >
  );
};

const Columns = ({ fields, meta, readOnly }) => {
  const addField = useCallback(() => {
    if (fields.length < 4) {
      fields.push({});
    } else {
      alert("Es können nicht mehr als 4 Hauptmenüpunkte hinzugefügt werden!");
    }
  }, [fields]);

  const removeField = useCallback((e) => {
    if (!e) return;
    const target = e.currentTarget || e.target;
    const index = Number(target.dataset.index);
    if (isNaN(index)) return;
    fields.remove(index);
  }, [fields]);

  const { touched, error, submitFailed } = meta || {};
  return (
    <>
      <div className="mt-one mb-1 fs-5 text-gray d-flex">Hauptmenüpunkte
        {!readOnly
          ? <button type="button"
            className="btn-link align-middle"
            onClick={addField}
          >
            <AddIcon>
            </AddIcon>
          </button>
          : null
        }
      </div>
      {(touched || submitFailed) && error && <span>{error}</span>}
      <div className="d-grid ps-one">
        {fields.map((mandantFooter, index) => {
          return (
            <div key={`row${mandantFooter}`}>
              <div className="d-flex align-items-start">
                <InputField
                  name={`${mandantFooter}.columnname`}
                  type="text"
                  label="Name"
                  readOnly={readOnly}
                />
                <InputField
                  name={`${mandantFooter}.columnorder`}
                  type="hidden"
                  label="Position"
                  invisible={true}
                />
                <button type="button"
                  className="btn-link align-middle"
                  title="Spalte löschen"
                  data-index={index}
                  onClick={removeField}
                  disabled={readOnly}
                >
                  <DeleteIcon aria-hidden="true" />
                </button>
              </div>
              <div className="d-grid w-100">
                <FieldArray name={`${mandantFooter}.rows`} component={Rows} props={{ readOnly }} />
              </div>
              <hr className="mt-1 mb-1" />
            </div>
          );
        })}
      </div >
    </>
  );
};

class FieldArraysForm extends React.Component {
  render() {
    return <FieldArray name="mandantFooterList" component={Columns} props={{ readOnly: this.props.readOnly }} />;
  }
};

export default (FieldArraysForm);
